import { render, staticRenderFns } from "./product-tos.vue?vue&type=template&id=0690ecc9&scoped=true"
import script from "./product-tos.vue?vue&type=script&lang=js"
export * from "./product-tos.vue?vue&type=script&lang=js"
import style0 from "./product-tos.vue?vue&type=style&index=0&id=0690ecc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690ecc9",
  null
  
)

export default component.exports